import DataGridFilterSearch from '../DataGrid/DataGridFilterSearch';
class AsyncDataGridFilterSearch extends DataGridFilterSearch {}
export default AsyncDataGridFilterSearch;